module.exports = __webpack_public_path__ + "assets/img/d4e7-md.svg";